var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 91,
    viewBox: "0 0 75 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_2117)",
    filter: "url(#filter0_i_54_2117)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2921 6.15525H61.946V3.63076C61.946 2.83743 61.6881 2.07658 61.229 1.51553C60.7698 0.954479 60.147 0.63916 59.4976 0.638916H17.8779C17.5563 0.638896 17.2378 0.716267 16.9406 0.866612C16.6435 1.01696 16.3735 1.23733 16.146 1.51515C15.9186 1.79297 15.7382 2.1228 15.6151 2.48579C15.492 2.84879 15.4286 3.23785 15.4286 3.63076V6.15525H8.7913C7.28941 6.15744 5.84955 6.88722 4.78755 8.18451C3.72555 9.48181 3.12813 11.2407 3.12634 13.0753V17.5583C3.08924 21.1505 3.82335 24.6918 5.25552 27.8294C6.68769 30.9671 8.76793 33.5915 11.289 35.4413C13.4804 36.9855 15.9319 37.8969 18.456 38.106C18.51 38.1104 18.564 38.1126 18.618 38.1127C18.7072 38.1093 18.7962 38.099 18.8843 38.082C21.3134 42.9042 24.8627 46.734 29.0799 49.0833C30.6225 49.9767 31.9228 51.3919 32.8268 53.161C33.7307 54.93 34.2003 56.9787 34.1799 59.0639V64.2012C34.1799 65.1217 33.8807 66.0045 33.3479 66.6554C32.8152 67.3064 32.0925 67.6721 31.339 67.6722H25.4656C24.5515 67.6723 23.6748 68.1159 23.0284 68.9056C22.382 69.6952 22.0188 70.7661 22.0188 71.8828V73.6389H18.3753C17.3698 73.6389 16.4055 74.1424 15.6944 75.0386C14.9834 75.9347 14.584 77.1502 14.584 78.4176V83.1999C14.5839 83.3889 14.6134 83.576 14.6708 83.7506C14.7281 83.9252 14.8121 84.0838 14.9181 84.2174C15.0241 84.3511 15.1499 84.4571 15.2884 84.5294C15.4269 84.6017 15.5754 84.6389 15.7253 84.6389H61.359C61.6618 84.6389 61.9522 84.4873 62.1663 84.2175C62.3804 83.9476 62.5007 83.5816 62.5007 83.1999V78.4183C62.5007 77.7906 62.4027 77.1691 62.2122 76.5893C62.0217 76.0094 61.7424 75.4825 61.3903 75.0387C61.0382 74.5949 60.6203 74.2429 60.1602 74.0027C59.7002 73.7625 59.2071 73.6389 58.7092 73.6389H55.3563V71.8821C55.3562 70.7655 54.9929 69.6946 54.3465 68.9052C53.7 68.1157 52.8234 67.6722 51.9093 67.6722H46.0358C45.2822 67.6722 44.5595 67.3065 44.0267 66.6556C43.4938 66.0047 43.1945 65.1219 43.1944 64.2014V59.0633C43.174 56.978 43.6436 54.9293 44.5476 53.1602C45.4517 51.3912 46.7521 49.976 48.2947 49.0827C52.503 46.7386 56.0465 42.9204 58.4755 38.1124C58.5257 38.1124 58.5766 38.1101 58.6272 38.106C61.1509 37.8972 63.6021 36.9857 65.793 35.4413C68.3143 33.5917 70.3948 30.9673 71.8272 27.8297C73.2596 24.692 73.9939 21.1506 73.957 17.5583V13.0753C73.9552 11.2407 73.3578 9.48181 72.2958 8.18451C71.2338 6.88722 69.7939 6.15744 68.2921 6.15525ZM13.4901 30.7942C11.6355 29.4169 10.1086 27.4703 9.0613 25.1481C8.01404 22.826 7.48298 20.2092 7.521 17.5583V13.0753C7.52136 12.6639 7.65531 12.2695 7.89346 11.9786C8.13161 11.6877 8.45451 11.524 8.7913 11.5236H15.4286V23.2112C15.4305 26.3119 15.8492 29.3913 16.668 32.3263C15.5542 32.004 14.4839 31.488 13.4901 30.7942ZM69.5624 17.5582C69.6002 20.2093 69.069 22.8263 68.0215 25.1486C66.974 27.471 65.4468 29.4177 63.592 30.7949C62.6943 31.4231 61.7334 31.9061 60.7337 32.2318C61.5352 29.3248 61.9448 26.2781 61.9465 23.2107V11.5231H68.2921C68.6288 11.5236 68.9517 11.6872 69.1899 11.9781C69.428 12.269 69.562 12.6635 69.5624 13.0749V17.5582ZM39.5839 11.0673L42.4607 19.6013H51.7705L44.2388 24.8757L47.1156 33.4097L39.5839 28.1354L32.0521 33.4097L34.929 24.8757L27.3972 19.6013H36.707L39.5839 11.0673Z",
    fill: "#FFD700",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_54_2117",
    x: 0,
    y: 0.638916,
    width: 75,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_54_2117"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_2117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 90,
    fill: "white",
    transform: "translate(0 0.638916)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinCup);
export default __webpack_public_path__ + "static/media/winCup.16ab501108d64c78e05b92f283ba0999.svg";
export { ForwardRef as ReactComponent };